import React from "react"
import { type RouteObject } from "react-router-dom"

import { PermissionGate } from "../../../../components/PermissionGate/PermissionGate.tsx"
import { RoutesPaths } from "../../../../constants/routes.ts"
import { lazyPage } from "../lazyPage.tsx"

const DocumentContractCreatePage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentContractCreatePage.tsx")
)
const DocumentContractEditPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentContractEditPage.tsx")
)
const DocumentProposalCreatePage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentProposalCreatePage.tsx")
)
const DocumentProposalEditPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentPages/DocumentProposalEditPage.tsx")
)
const DocumentTemplateAddPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentTemplatePages/DocumentTemplateAddPage.tsx")
)
const DocumentTemplateEditPage = lazyPage(
  () =>
    import("../../../DocumentTemplates/DocumentTemplatePages/DocumentTemplateEditPage.tsx")
)
export const templatesRoutes: RouteObject[] = [
  {
    path: RoutesPaths.documentTemplates.add,
    element: (
      <PermissionGate
        paths={[
          "settings.document_templates.settings_proposal_template_create"
        ]}
      >
        <DocumentTemplateAddPage />
      </PermissionGate>
    )
  },
  {
    path: RoutesPaths.documentTemplates.edit(":id"),
    element: (
      <PermissionGate
        paths={["settings.document_templates.settings_proposal_template_edit"]}
      >
        <DocumentTemplateEditPage />
      </PermissionGate>
    )
  },
  // Proposal Document
  {
    path: RoutesPaths.proposalDocument.create(":templateId", ":leadId"),
    element: <DocumentProposalCreatePage />
  },
  {
    path: RoutesPaths.proposalDocument.edit(":id"),
    element: <DocumentProposalEditPage />
  },
  // Contract Document
  {
    path: RoutesPaths.contractDocument.create.path,
    element: <DocumentContractCreatePage />
  },
  {
    path: RoutesPaths.contractDocument.edit(":id"),
    element: <DocumentContractEditPage />
  }
]
